// Mirrors pkg/web's knownLoginNotices allowlist exactly (see that file's comment for the
// full reasoning): /login?notice=... is a URL anyone can construct and send to a visitor,
// so an arbitrary value must not be rendered as if the app itself produced it — that is a
// content-spoofing / phishing vector, not something HTML-escaping alone closes, since the
// text itself is what would be misleading.
const KNOWN_NOTICES = new Set([
  'Je sessie is verlopen. Log opnieuw in.',
  'Je e-mail is bevestigd, maar inloggen lukte niet automatisch. Log handmatig in of neem contact op met hallo@mentiontrend.com.',
  'Inloggen lukte niet. Neem contact op met hallo@mentiontrend.com als dit blijft gebeuren.',
  '2FA is ingeschakeld. Log opnieuw in met je verificatiecode.',
])

export function safeNotice(raw: string | null): string {
  if (!raw) return ''
  return KNOWN_NOTICES.has(raw) ? raw : ''
}
